module.exports = __webpack_public_path__ + "assets/static/png/sim-card-grey.3fbdb054e713d398fd7230e2fddebf9b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/sim-card-grey.png
 ** module id = 519
 ** module chunks = 1
 **/